import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { RecentSearch } from './recent-search.service';
import { filter } from 'rxjs/operators';
import { SearchControllerService, SearchDtoSearchTypeEnum } from '@scip/api';
import { AdvancedProductSearchDto, AdvancedSubmissionSearchDto, SearchDto } from '@scip/api';
import { BackendErrorService } from './backend-error.service';

export interface ProductSearch {
  searchId: number;
  recentSearch: RecentSearch;
}
export interface SubmissionSearch {
  searchId: number;
  recentSearch: RecentSearch;
  showChildren?: boolean;
}

export enum SearchType {
  'PRODUCT_ADVANCED' = 'PRODUCT_ADVANCED',
  'PRODUCT_QUICK' = 'PRODUCT_QUICK',
  'SUBMISSION_ADVANCED' = 'SUBMISSION_ADVANCED',
  'SUBMISSION_QUICK' = 'SUBMISSION_QUICK'
}

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private productSearchEvent: ReplaySubject<ProductSearch> = new ReplaySubject(1);
  private submissionSearchEvent: ReplaySubject<SubmissionSearch> = new ReplaySubject(1);

  constructor(private searchControllerService: SearchControllerService, private backendErrorService: BackendErrorService) {}

  cleanSearchCaches(): void {
    this.productSearchEvent.next();
    this.submissionSearchEvent.next();
  }

  getProductSearchEvents(): Observable<ProductSearch> {
    return this.productSearchEvent.asObservable().pipe(filter((event: ProductSearch) => !!event));
  }

  getSubmissionSearchEvents(): Observable<SubmissionSearch> {
    return this.submissionSearchEvent.asObservable().pipe(filter((event: SubmissionSearch) => !!event));
  }

  emitProductSearchEvent(value: ProductSearch): void {
    this.productSearchEvent.next(value);
  }

  emitSubmissionSearchEvent(value: SubmissionSearch): void {
    this.submissionSearchEvent.next(value);
  }

  createSearch(
    type: SearchDtoSearchTypeEnum,
    searchParams: Record<string, string> | AdvancedProductSearchDto | AdvancedSubmissionSearchDto,
    additionalEventContent?: Record<string, unknown>
  ): void {
    const payload: SearchDto = {
      searchObject: JSON.stringify(searchParams),
      searchType: type
    };

    this.searchControllerService.createSearch(payload).subscribe(
      (searchId) => {
        switch (type) {
          case SearchDtoSearchTypeEnum.ProductAdvanced:
          case SearchDtoSearchTypeEnum.ProductQuick:
            this.emitProductSearchEvent({
              searchId,
              recentSearch: undefined
            });
            break;
          case SearchDtoSearchTypeEnum.SubmissionAdvanced:
          case SearchDtoSearchTypeEnum.SubmissionQuick:
            this.emitSubmissionSearchEvent({
              searchId,
              recentSearch: undefined,
              ...additionalEventContent
            });
            break;
        }
      },
      (err) => {
        this.backendErrorService.handleError(err);
      }
    );
  }
}
